// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"1":"47e213884196cf439aba","2":"d7371c70b3f9c6ce7690","3":"085d6680ecfe3037d6cd"}[chunkId] + ".js";
};